import React from "react";
import { X } from "lucide-react";
import {
  ACTION_MODAL_BODY,
  ACTION_MODAL_FOOTER,
  ACTION_MODAL_HEADER,
  ACTION_MODAL_OVERLAY,
  ACTION_MODAL_SHELL,
} from "./actionUiChrome";

export function ActionFormOverlay({ children, onClose, className = "" }) {
  return (
    <div
      className={`${ACTION_MODAL_OVERLAY} ${className}`.trim()}
      onClick={onClose}
      role="presentation"
    >
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>
  );
}

export function ActionFormShell({
  children,
  className = "",
  maxWidthClass = "w-[min(100%,720px)]",
}) {
  return (
    <div className={`${ACTION_MODAL_SHELL} ${maxWidthClass} ${className}`.trim()}>
      {children}
    </div>
  );
}

export function ActionFormHeader({ title, subtitle = null, onClose, trailing = null }) {
  return (
    <div className={ACTION_MODAL_HEADER}>
      <div className="min-w-0">
        {title ? (
          <h3 className="text-base font-semibold tracking-tight text-[hsl(var(--ds-fg))]">
            {title}
          </h3>
        ) : null}
        {subtitle ? (
          <p className="mt-0.5 text-xs text-[hsl(var(--ds-muted-fg))]">{subtitle}</p>
        ) : null}
      </div>
      <div className="flex shrink-0 items-center gap-1">
        {trailing}
        {onClose ? (
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-[hsl(var(--ds-muted-fg))] transition hover:bg-[hsl(var(--ds-muted))]"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        ) : null}
      </div>
    </div>
  );
}

export function ActionFormBody({ children, className = "" }) {
  return <div className={`${ACTION_MODAL_BODY} ${className}`.trim()}>{children}</div>;
}

export function ActionFormFooter({ children, className = "" }) {
  return <div className={`${ACTION_MODAL_FOOTER} ${className}`.trim()}>{children}</div>;
}
